import { memo, useCallback, useContext } from "react"
import { FilesUploadContext } from "./FilesUpload"
import styled from "styled-components"
import clsx from "clsx"

const UploadButton = styled.button`
  &.disabled {
    cursor: not-allowed;
  }
`

interface FilesUploadButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children?: React.ReactNode
  disabled?: boolean
}

export const FilesUploadButton = (props: FilesUploadButtonProps) => {
  const { children, disabled = false, ...rest } = props

  const { filesRef } = useContext(FilesUploadContext)

  const handleClick = useCallback(() => {
    if (filesRef.current) {
      filesRef.current.click()
      filesRef.current.value = ""
    }
  }, [filesRef.current])

  return (
    <UploadButton type="button" className={clsx({ disabled })} disabled={disabled} onClick={handleClick} {...rest}>
      {children}
    </UploadButton>
  )
}

export default memo(FilesUploadButton)
